<div class="how-to-play-container">
  <app-help-items></app-help-items>
</div>
